import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static MustMatch(control: AbstractControl) {
    const password: string = control.get('password').value; // get password from our password form control
    const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
    }
  }

  static DateFieldRageValidator(controlName: string, minValue: number, maxValue: number): ValidatorFn {
    
    // TODO: THIS METHOD IS DEPRECATED, USE DateRangeValidator INSTEAD

    return (control: AbstractControl): { [key: string]: any } => {
      var datefld = new Date(control.value);
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      var today = new Date();
      var newDate = new Date();
      var d = this.addDays(today, -minValue);
      if (datefld < new Date(d.toDateString())) {
        return { key: 'Date cannot be earlier than ' + datefld.getDate() };
      }

      let toDate = this.addDays(new Date(), maxValue);
      
      if (datefld > toDate) {
        return { key: 'Date cannot be later than ' + toDate.getDate() };
      }

      return null;
    }
  }

  static DateRangeValidator(controlName: string, minDate: Date, maxDate: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var datefld = new Date(control.value);
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      if (datefld < minDate) {
        return { key: 'Date cannot be earlier than ' + minDate.getDate() };
      }

      if (datefld > maxDate) {
        return { key: 'Date cannot be later than ' + maxDate.getDate() };
      }

      return null;
    }
  }


  static DateFormatValidator(controlName: string, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      let controlValue: string = "";
      if (typeof control.value != "string") {
        const controlDate = new Date(control.value);
        const month = String(controlDate.getMonth() + 1).padStart(2, '0');
        const day = String(controlDate.getDate()).padStart(2, '0');
        const year = controlDate.getFullYear().toString();

        controlValue = day + "/" + month + "/" + year;
      } else {
        controlValue = control.value.substring(0, control.value.indexOf("T")).split('-').reverse().join('/');
      }
      
      let regPattern = /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;

      const valid = regPattern.test(controlValue);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    }
  }

  static addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

}

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


